module.exports = __webpack_public_path__ + "img/Atelier_1.93681f6c.jpg";